module.exports = __webpack_public_path__ + "img/herramientas.ff7c7025.svg";